// extracted by mini-css-extract-plugin
export default {"label":"TextAreafieldComponent_label__JknM-"};